import { useTranslation } from '../../i18n'
import { useAuth } from '../../contexts/AuthContext'
import { useTheme } from '../../hooks/useTheme'

/**
 * Home notice when the current user has no Telegram @username.
 * Coaches cannot invite without it — keep the message short and clear.
 */
export function UsernameWarning() {
  const { user } = useAuth()
  const { t } = useTranslation()
  const theme = useTheme()

  if (user?.username) {
    return null
  }

  return (
    <div
      className="mb-5 rounded-2xl overflow-hidden"
      style={{
        backgroundColor: theme.cardBg,
        border: `1px solid ${theme.cardBorder}`,
        boxShadow: theme.shadow.card,
      }}
    >
      <div className="flex">
        <div
          className="w-1 shrink-0 self-stretch"
          style={{ backgroundColor: theme.buttonColor }}
          aria-hidden
        />

        <div className="flex-1 min-w-0 px-4 py-4">
          <div className="flex items-start gap-3">
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
              style={{
                backgroundColor: `${theme.buttonColor}18`,
                color: theme.accent.text,
              }}
              aria-hidden
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="4" />
                <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
              </svg>
            </div>

            <div className="flex-1 min-w-0">
              <p
                className="text-sm font-bold leading-snug"
                style={{ color: theme.text.primary }}
              >
                {t.dashboard.usernameWarning.title}
              </p>
              <p
                className="text-xs mt-1.5 leading-relaxed"
                style={{ color: theme.text.muted }}
              >
                {t.dashboard.usernameWarning.message}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
